import React, { useContext, useState } from "react";
import css from "./Nav.module.css";

import { Button, Col, Container, Navbar, Row } from "react-bootstrap";
import { UserContext } from "../context/UserContext";
import { Link, useNavigate } from "react-router-dom";
import { Rotas } from "../utils/Rotas";

function NavTop() {
  const { user, setUser } = useContext(UserContext);
  const navigator = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  // Datas
  const [date] = useState(new Date());
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");



  function logoutUser() {
      setUser((prev) => ({
          ...prev,
          login: 'false',
      }))
      navigator('/login')
  }

  function toggleMenu() {
      setMenuOpen(!menuOpen)
  }

  return (
      <Navbar className={css.NavBar}>
          <Container className={css.flexMobile}>
              <Link to="/" className={css.title}>
                  Editor Manual
              </Link>
              <Row>
                  <Col className={css.datas}>
                      Data: {`${month}/${day}/${year}`}
                  </Col>

                  <Button onClick={() => logoutUser()}>Logout</Button>
              </Row>
              <div className={`${css.sidebar} ${menuOpen ? css.open : ''}`}>
                  {Rotas.filter(
                      (item) => item.tipoUser === user.user?.role
                  ).map((item, index) => {
                      return (
                          <Link
                              to={item.link}
                              key={index}
                              className={css.botaoSideNav}
                              onClick={toggleMenu}
                          >
                              {item.name}
                          </Link>
                      )
                  })}
              </div>
          </Container>
      </Navbar>
  )
}

export default NavTop;
